export default "__VITE_ASSET__Bd09e_vl__"